var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 123,
    viewBox: "0 0 85 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8552 0.292971C11.1653 1.10761 8.36204 2.68897 5.48683 5.5402C3.06688 7.96017 1.74908 10.0447 0.646919 13.2313L0 15.1482V61.2711V107.394L0.646919 109.311C1.74908 112.474 3.06688 114.582 5.48683 117.002C7.9068 119.422 10.0153 120.739 13.178 121.842L15.0948 122.489H42.2894H69.4839L71.4007 121.842C74.5635 120.739 76.6719 119.422 79.0919 117.002C81.5119 114.582 82.8297 112.474 83.9079 109.311L84.5787 107.394V99.9425V92.5149L84.0037 91.6524C82.9495 90.1429 81.9911 89.6637 79.9066 89.6637C77.8221 89.6637 76.8636 90.1429 75.8094 91.6524C75.2583 92.491 75.2344 92.6587 75.0905 98.7446C74.9229 105.597 74.7791 106.364 73.4374 108.472C71.9279 110.844 69.5079 112.354 66.6088 112.785C64.3565 113.097 20.2222 113.097 17.97 112.785C13.6093 112.162 10.3267 108.88 9.70379 104.519C9.39231 102.219 9.39231 20.3236 9.70379 18.0233C10.3267 13.6626 13.6093 10.3801 17.97 9.75716C20.2222 9.44569 64.3565 9.44569 66.6088 9.75716C70.9695 10.3801 74.252 13.6626 74.8749 18.0233C74.9948 18.9338 75.1146 21.5455 75.1146 23.7978C75.1146 27.6074 75.1624 27.9668 75.6657 28.9491C77.3908 32.2317 82.3984 32.2077 84.1474 28.9252C84.7226 27.8469 84.7226 27.823 84.6507 21.4976C84.5548 15.3638 84.5309 15.0763 83.9079 13.2313C82.8537 10.0926 81.5359 7.98412 79.0919 5.5402C76.6719 3.12025 74.5635 1.80245 71.4007 0.70029L69.4839 0.0533705L42.8883 0.00545056C21.5161 -0.0185094 16.0053 0.0294106 14.8552 0.292971Z",
    fill: "url(#paint0_linear_1112_960)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.461 17.2807C31.9867 18.8381 31.6992 23.8936 34.9818 25.9302L36.1318 26.6491H42.2895H48.4473L49.5974 25.9302C51.2746 24.9 51.9455 23.5582 51.8257 21.4737C51.7299 19.6767 51.1547 18.5985 49.7651 17.6401C48.9265 17.065 48.8307 17.065 42.5531 17.0172C37.6174 16.9692 36.0121 17.0172 35.461 17.2807Z",
    fill: "url(#paint1_linear_1112_960)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2532 96.3246C36.8029 97.906 36.4914 102.962 39.726 104.95C42.0741 106.412 45.2608 105.597 46.5306 103.201C47.0098 102.315 47.1057 101.859 47.0338 100.542C46.9379 98.7445 46.3629 97.6663 44.9733 96.7079C43.9669 96.013 41.4032 95.8214 40.2532 96.3246Z",
    fill: "url(#paint2_linear_1112_960)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1112_960",
    x1: -38,
    y1: -50,
    x2: 136.5,
    y2: 183.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6250FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893217,
    stopColor: "#C2D6F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1112_960",
    x1: 33,
    y1: 17,
    x2: 70.5,
    y2: 34.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6250FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2D6F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1112_960",
    x1: 38.5302,
    y1: 96.1665,
    x2: 57,
    y2: 116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6250FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367222,
    stopColor: "#C2D6F3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppFrame);
export default __webpack_public_path__ + "static/media/App-frame.675ecb7c5cf3ea1dcf04715ce55ac8da.svg";
export { ForwardRef as ReactComponent };